<template>
  <div class="login_bg_box">
    <div class="login_bg">
      <div class="SignIn">
        <div class="SignIn_title">
          <div>用户登录</div>
        </div>
        <div style="width: 100%; margin-top: 20px">
          <el-form class="SignIn_form" :model="form" ref="form">
            <el-form-item prop="username">
              <el-input ref="username" v-model="form.username" size="medium" placeholder="请输入登录账号"
                @keyup.enter.native="getlogin"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input ref="password" show-password v-model="form.password" placeholder="请输入密码" type="password" size="medium"
                @keyup.enter.native="getlogin"></el-input>
            </el-form-item>
            <el-form-item prop="psGraphicCode">
              <div class="code-row">
                <el-input ref="psGraphicCode" v-model="form.psGraphicCode" size="medium" placeholder="请输入图形验证码"
                  maxlength="4" @keyup.enter.native="getlogin"></el-input>
                <img class="code-img" :src="codeImg" alt="点击刷新" title="点击刷新" @click="refreshImageCode" />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="SignIn_btn">
          <el-button type="primary" :disabled="loginText == '登录中...'" @click="getlogin">{{
            loginText
          }}</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="800px" :modal="true" @close="closeDialog"
      :close-on-click-modal="false" center>
      <div>
        <el-form :model="updateFormData" :rules="rulesPassword" ref="ruleFormPassword" label-width="100px">
          <el-form-item prop="old" label="原密码">
            <el-input show-password v-model="updateFormData.old" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input show-password v-model="updateFormData.newPassword" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item prop="confirmNewPassword" label="确认新密码">
            <el-input show-password v-model="updateFormData.confirmNewPassword" placeholder="请输入确认新密码"></el-input>
          </el-form-item>
        </el-form>
        <!-- <div class="tips">
          备注：密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" class="search" size="mini" @click="updatePassword">
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  name: "Login",
  data() {
    return {
      codeImg: "",
      form: {
        username: "",
        password: "",
        codeKey: "", // 图形验证码key
        psGraphicCode: "" // 密码登录-图形验证码
      },
      key: "u9dYuYlGVk39kkb5",
      prefix: window.location.href, //当前路径
      baseUrl: process.env.VUE_APP_API_DOMAIN + "/tbase-iam-service/iam", //基础路径
      // baseUrl:"/tbase-iam-service/iam", //基础路径
      loginText: "登 录",
      dialogVisible: false,
      updateFormData: {
        old: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      rulesPassword: {
        // old: [
        //   {
        //     required: true,
        //     message: "请输入原密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
        // newPassword: [
        //   {
        //     required: true,
        //     message: "请输入新密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
        // confirmNewPassword: [
        //   {
        //     required: true,
        //     message: "请输入确认密码",
        //     trigger: "blur",
        //   },
        //   {
        //     // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
        //     pattern: "/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,10}$/",
        //     message: "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！",
        //   },
        // ],
      }
    };
  },
  created() {
    if (this.$route.query.ticket) {
      this.$axios
        .get(
          process.env.VUE_APP_API_DOMAIN +
          `/tbase-iam-service/iam/common/loginByThreeKey?principal=${encodeURIComponent(this.encryptByAES(this.$route.query.ticket, this.key))}&modelType=10`,
        )
        // 测试手机号登录
        // .get(
        //   `http://134.175.8.70:9299/dev-zgc-api-gw/tbase-iam-service/iam/common/loginByThreeKey?principal=${encodeURIComponent(this.encryptByAES(this.$route.query.ticket, this.key))}&modelType=2`,
        // )
        .then(res => {
          console.log(res);
          this.loginText = "登 录";
          let result = res.data;
          if (result.code === 200) {
            if (!result.data.userInfo.zcUserType.includes('gov')) return this.$router.push({ path: "/forbidden"});
            sessionStorage.setItem("access_token", result.data.accessToken);
            sessionStorage.setItem("userInfo", JSON.stringify(result.data.userInfo));
            sessionStorage.setItem("zc_code", result.data.userInfo.zcId);
            if (result.data.userInfo.roles && result.data.userInfo.roles.length) {
              let str =
                result.data.userInfo.roles.find(role => role.roleCode == "JG") || "";
              sessionStorage.setItem("isJG", str ? 1 : 0);
              let strGLLD = result.data.userInfo.roles.find(role => role.roleCode == "GLLD") || "";
              sessionStorage.setItem("strGLLD", strGLLD ? 1 : 0);
            } else {
              sessionStorage.setItem("isJG", 0);
              sessionStorage.setItem("strGLLD", 0);
            }
            if (sessionStorage.getItem("redirectUri")) {
              window.location.href = sessionStorage.getItem("redirectUri");
              sessionStorage.removeItem("redirectUri"); // 认证跳转成功后清空掉sessionStorage缓存的地址
            } else if (result.data.userInfo && result.data.userInfo.passwordExpiredTime) {
              let currentTime = Date.parse(new Date());
              let timeDifference =
                result.data.userInfo.passwordExpiredTime - currentTime;
              if (timeDifference < 0) {
                this.$message({
                  type: "warning",
                  message: "你的密码已过期",
                  duration: 5000
                });
                this.$router.push({
                  path: "/forbidden"
                });
              } else {
                this.$router.push({
                  path: "/Portal"
                });
              }
            } else {
              this.$router.push({
                path: "/Portal"
              });
            }
          } else {
            this.$message({
              message: result.msg,
              type: "warning"
            });
            this.$router.push({
              path: "/forbidden"
            });
          }
        });
    }
  },
  mounted() {
    this.$axios.defaults.withCredentials = true;
    this.preHandle(); // 截取请求地址中的重定向地址和token
    // 刷新图形验证码
    this.refreshImageCode();
  },
  methods: {
    // 截取请求地址中的重定向地址和token
    preHandle() {
      let currentLocation = document.location.href;
      let index1, index2, index3;
      // 示例地址：http://localhost:8080/?redirect_uri=http://134.175.8.70:30578&access_token=0IpKB7sgVXwss8EAg
      // 第三方应用退出登录重定向到登录页面时，会携带重定向地址和token
      if (
        currentLocation.includes("?redirect_uri") &&
        currentLocation.includes("&access_token")
      ) {
        index1 = currentLocation.indexOf("=");
        index2 = currentLocation.indexOf("&");
        index3 = currentLocation.lastIndexOf("=");
        let redirectUri = currentLocation.substring(index1 + 1, index2);
        sessionStorage.setItem("redirectUri", redirectUri);
        let accessToken = currentLocation.substring(index3 + 1);
        if (accessToken.includes("#/")) {
          accessToken = accessToken.substring(0, accessToken.length - 2);
        }
        this.clearOldToken(accessToken); // 第三方应用退出登录时调用认证中心移除token接口
        // sessionStorage.setItem('loginArrress', currentLocation.substring(0, currentLocation.indexOf('?')))
        window.location = currentLocation.substring(
          0,
          currentLocation.indexOf("?")
        );
      } else if (currentLocation.includes("?redirect_uri")) {
        // 示例地址：http://localhost:8080/?redirect_uri=http://134.175.8.70:30578
        // 在未登录的情况下，直接访问第三方应用，会携带重定向地址
        index1 = currentLocation.indexOf("=");
        let redirectUri = currentLocation.substring(index1 + 1);
        if (redirectUri.includes("#/")) {
          redirectUri = redirectUri.substring(0, redirectUri.length - 2);
        }
        sessionStorage.setItem("redirectUri", decodeURIComponent(redirectUri));
        // sessionStorage.setItem('loginArrress', currentLocation.substring(0, currentLocation.indexOf('?')))
        window.location = currentLocation.substring(
          0,
          currentLocation.indexOf("?")
        );
      }
    },
    // 第三方应用退出登录时调用认证中心移除token接口
    clearOldToken(oldToken) {
      this.$axios({
        method: "get",
        url: this.baseUrl + "/oauth/remove/token?access_token=" + oldToken
      }).then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: "/"
          });
        }
      });
    },
    encryptByAES(message, key) {
      var iv = "LT0cYheDsyKGHENw";
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var ivHex = CryptoJS.enc.Utf8.parse(iv);
      var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    refreshImageCode() {
      this.loginText = "登 录";
      this.toA();
    },
    toA() {
      this.refreshA();
    },
    refreshA() {
      this.form.codeKey = Math.random();
      this.codeImg = this.baseUrl + `/code/imageCode/${this.form.codeKey}`;
      console.log(this.codeImg);
    },
    // 账号密码登录-点击登录按钮
    getlogin() {
      if (
        this.form.username == null ||
        this.form.username === "" ||
        this.form.username === undefined
      ) {
        this.$refs.username.focus();
        this.$message({
          message: "请输入用户名!",
          type: "warning"
        });
        return;
      } else if (
        this.form.password == null ||
        this.form.password === "" ||
        this.form.password === undefined
      ) {
        this.$message({
          message: "请输入密码!",
          type: "warning"
        });
        this.$refs.password.focus();
        return;
      } else if (
        this.form.psGraphicCode == null ||
        this.form.psGraphicCode === "" ||
        this.form.psGraphicCode === undefined
      ) {
        this.$message({
          message: "请输入图形验证码!",
          type: "warning"
        });
        this.$refs.psGraphicCode.focus();
        return;
      }
      if (this.loginText === "登录中...") {
        return;
      }
      this.loginText = "登录中...";
      // 先校验图形验证码是否正确，若正确 则提交登录表单请求
      this.checkImageCodeAndLogin();
    },
    // 校验图形验证码是否正确，若正确 则提交登录表单请求
    checkImageCodeAndLogin() {
      let that = this;
      this.$axios({
        method: "post",
        url: this.baseUrl + "/code/imageCode/check",
        data: {
          codeKey: this.form.codeKey,
          imageCode: this.form.psGraphicCode
        }
      })
        .then(res => {
          if (res.data.code === 200) {
            // 若校验通过，则提交登录表单请求
            that.submitLoginForm();
          } else {
            // 若校验不通过，则抛异常
            that.$message({
              message: res.data.msg,
              type: "warning"
            });

            // 刷新图形验证码
            that.refreshImageCode();
          }
        })
        .catch(err => {
          // 若校验不通过，则抛异常
          // this.$message({
          //   message: err.response.data.msg,
          //   type: "warning"
          // });
          // 刷新图形验证码
          this.refreshImageCode();
        });
    },

    // 提交登录表单请求
    submitLoginForm() {
      let that = this;
      let formData = new FormData();
      formData.append(
        "username",
        this.encryptByAES(that.form.username, this.key)
      );
      formData.append(
        "password",
        this.encryptByAES(that.form.password, this.key)
      );
      // formData.append("loginType", 1);
      formData.append("prefix", window.location.origin);
      formData.append("userSource", 1);
      formData.append("loginType", 1);
      this.$axios
        .post(
          process.env.VUE_APP_API_DOMAIN +
          "/tbase-iam-service/iam/auth/doLogin",
          formData
        )
        .then(res => {
          console.log(res);
          this.loginText = "登 录";
          let result = res.data;
          if (result.code === 200) {
            if (!result.userInfo.zcUserType.includes('gov')) return this.$message({type: "warning",message: "账号身份暂不允许登入！",duration: 5000});
            sessionStorage.setItem("access_token", result.accessToken);
            sessionStorage.setItem("userInfo", JSON.stringify(result.userInfo));
            sessionStorage.setItem("zc_code", result.userInfo.zcId);
            if (result.userInfo.roles && result.userInfo.roles.length) {
              let str =
                result.userInfo.roles.find(role => role.roleCode == "JG") || "";
              sessionStorage.setItem("isJG", str ? 1 : 0);
              let strGLLD = result.userInfo.roles.find(role => role.roleCode == "GLLD") || "";
              sessionStorage.setItem("strGLLD", strGLLD ? 1 : 0);
            } else {
              sessionStorage.setItem("isJG", 0);
              sessionStorage.setItem("strGLLD", 0);
            }
            if (sessionStorage.getItem("redirectUri")) {
              window.location.href = sessionStorage.getItem("redirectUri");
              sessionStorage.removeItem("redirectUri"); // 认证跳转成功后清空掉sessionStorage缓存的地址
            } else if (result.userInfo && result.userInfo.passwordExpiredTime) {
              let currentTime = Date.parse(new Date());
              let timeDifference =
                result.userInfo.passwordExpiredTime - currentTime;
              if (timeDifference < 0) {
                this.$message({
                  type: "warning",
                  message: "你的密码已过期，请修改密码！",
                  duration: 5000
                });
                this.openDialog();
              } else {
                this.$router.push({
                  path: "/Portal"
                });
              }
            } else {
              this.$router.push({
                path: "/Portal"
              });
            }
          } else {
            this.$message({
              message: result.msg,
              type: "warning"
            });
          }
        });
    },
    closeDialog() {
      this.formData.old = "";
      this.formData.newPassword = "";
      this.formData.confirmNewPassword = "";
    },
    openDialog() {
      this.dialogVisible = true;
      if (this.$refs.ruleFormPassword) {
        this.$nextTick(() => {
          this.$refs["ruleFormPassword"].clearValidate();
        });
      }
    },
    // 修改密码
    async updatePassword() {
      let xx = true;
      this.$refs["ruleFormPassword"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        // if (this.formData.confirmNewPassword=='' || this.formData.newPassword=='') {
        //   this.$message({
        //   message: '请输入或选择必填项',
        //     type: 'warning'
        //   });
        // }
        return false;
      }
      if (
        this.updateFormData.confirmNewPassword !=
        this.updateFormData.newPassword
      ) {
        this.$message({
          message: "两次密码不一致",
          type: "warning"
        });
        return false;
      }
      let params = {
        newPassword: this.encryptByAES(
          this.updateFormData.newPassword,
          this.key
        ),
        old: this.encryptByAES(this.updateFormData.old, this.key)
      };
      this.$axios
        .post(
          process.env.VUE_APP_API_DOMAIN + "/tbase-iam-manage/user/password",
          params
        )
        .then(res => {
          let result = res.data;
          if (result.code === 200) {
            this.$message({
              type: "success",
              message: "密码修改成功"
            });
            this.dialogVisible = false;
          } else {
            this.$message.warning(res.data.msg);
          }
          // const res = await setUserPassword(params);
          // if (res.data.code == 200) {
          //   this.$message({
          //     message: "修改密码成功",
          //     type: "success",
          //   });
          //   this.dialogVisible = false;
          //   // this.login()
          // } else {
          //   this.$message({
          //     message: `${res.data.msg}`,
          //     type: "warning",
        });
      // }
    }
  }
};
</script>

<style scoped lang="less">
.login_bg_box {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(225deg, #581da4 0%, #1a7abc 100%);

  .login_bg {
    height: 100%;
    width: 100%;
    position: relative;
    background: url("../../assets/image/login_bg.png") center center no-repeat;

    .SignIn {
      width: 30%;
      height: 50%;
      position: absolute;
      right: 5%;
      top: 30%;
      padding: 15px;

      .SignIn_title {
        width: 100%;
        height: 10%;
        font-size: 24px;
        color: #ffffff;
      }

      .SignIn_form {
        /deep/ .el-input--medium .el-input__inner {
          height: 48px;
          line-height: 48px;
          background-color: rgba(255, 255, 255, 0.1);
          color: #ffffff;
        }

        .code-row {
          display: flex;
          align-items: center;

          /deep/ .el-input {
            flex: 1;
          }

          .code-img {
            width: 110px;
            height: 48px;
            margin-left: 10px;
            border-radius: 4px;
            background: #fff;
            cursor: pointer;
            flex-shrink: 0;
          }
        }
      }

      .SignIn_btn {
        /deep/ .el-button--primary {
          width: 100%;
          height: 48px;
          font-size: 20px;
          //line-height: 48px;
          background: linear-gradient(270deg, #00d0e4 0%, #1392f2 100%);
        }
      }
    }
  }

  .getVerifyCls {
    width: 38%;
    height: 100%;
    margin-left: 2%;

    img {
      height: 100%;
      width: 100%;
    }

    .tuxing-btn {
      width: 100%;
      height: 100%;
      background-color: rgba(3, 84, 255, 1);
      color: #fff;
      border: none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue